import React from 'react';
import PropTypes from 'prop-types';
import { WizardStylesProvider } from '../WizardStylesContext';
import FormdataWizard from 'react-formdata-wizard';
import ReplyStep from './ReplyStep';

function ReplyWizard(props) {
  const { marketId, commentId, isSubtask, isNote, groupedType } = props;

  return (
    <WizardStylesProvider>
      <FormdataWizard name={`reply_wizard${commentId}`} defaultFormData={{useCompression: true}}>
        <ReplyStep marketId={marketId} commentId={commentId} isSubtask={isSubtask} isNote={isNote}
                   groupedType={groupedType} />
      </FormdataWizard>
    </WizardStylesProvider>
  );
}

ReplyWizard.propTypes = {
  commentId: PropTypes.string.isRequired
};
export default ReplyWizard;

